import { ClientAlertForm, ClientForm } from "../../types/clients";
import * as React from "react";
import { Severity } from "../../types/types";
import { ManageContactsButton } from "./ManageContactsButton";
import {useEffect, useState} from "react";
import NumberInputWithCommas from '../shared/NumberInputWithCommas';

export default function RCGrid(props: {
  title: string,
  clientForm: ClientForm,
  alerts: ReadonlyArray<ClientAlertForm>,
  limitName: 'RC1' | 'RC2' | 'RC6' | 'REV',
  limitForRC: string,
  limitChangedEvent: (value: string) => void,
  alertChangedEvent: (alert: ClientAlertForm, alertValue: string) => void,
  displayManageContactsOverlay: (clientForm: ClientForm, disconnectedAlert: ClientAlertForm, severity: Severity) => void,
}
): JSX.Element {
  // TODO: add some Error Boundaries https://reactjs.org/docs/error-boundaries.html
  if (props.limitName === 'RC1' && props.alerts.length !== 1) {
    throw new Error('There must be no more or less than 1 alert for rc1.')
  } else if (props.limitName === 'REV' && props.alerts.length !== 1) {
    throw new Error('Rev is breaking')
  } else if (props.limitName !== 'RC1' && props.limitName !== 'REV' && props.alerts.length !== 3) { //TODO-REV: update this to the expected length
    throw new Error('There must be no more or less than 3 alerts for this rc.')
  }


  const disconnectAlerts = props.alerts.filter(value => {
    return value.thresholdInPercent === '100'
  })

  const sortedNonDisconnectAlerts = props.alerts
    .filter(value => value.thresholdInPercent !== '100')
    .sort((a, b) => a.index - b.index)


  const sortedNonDisconnectAlertsForRev = props.alerts
    .filter(value => value.thresholdInPercent === '100')
    .sort((a, b) => a.index - b.index)

  if (disconnectAlerts.length !== 1 && props.limitName !== 'REV') {
    throw new Error(
      `Only a single disconnect alert threshold should be configured. But we found ${disconnectAlerts.length}`,
    )
  }
  
  //TODO-REV: update this to the expected length
  if (props.limitName !== 'RC1' && props.limitName !== 'REV' && sortedNonDisconnectAlerts.length !== 2) {
    throw new Error(
      `Only two none disconnect alerts should be configured. But we found ${sortedNonDisconnectAlerts.length
      }`,
    )
  }

  const disconnectAlert = disconnectAlerts[0]

  return (
    <div>
      <h3>{props.title}</h3>
      <div className='manage-rc-grid'>
        {props.limitName === "REV" ? (
          <>
            {
              sortedNonDisconnectAlertsForRev.map((value, index) => {
                const severity = 'Warn'
                const labelClass = 'label--warn'
                return ( 
                  <React.Fragment key={index}>
                    <label className={labelClass}>{severity}</label>
                    <div>
                      <input
                        type='number'
                        value={value.thresholdInPercent}
                        onChange={(event) => props.alertChangedEvent(value, event.currentTarget.value)}
                        min='0'
                        className='inline-block input no-margin-bottom text-right'
                        required={true}
                      /> {' '}
                      <label className={labelClass + ' inline-block'}>%</label>
                    </div>
                    <ManageContactsButton clientForm={props.clientForm} disconnectedAlert={value} severity={severity}
                                          limitName={props.limitName}
                                          displayManageContactsOverlay={props.displayManageContactsOverlay}/>
                  </React.Fragment>
                )
              })
            }
          </>
        ) : (
          <>
            <label className='label--breach'>Breach</label>
            <div>
              <NumberInputWithCommas
                value={props.limitForRC} // The numeric limit value
                onChange={(_, rawValue) => props.limitChangedEvent(rawValue)} // Ignore the first argument as it's not an alert change
                required={true}
              />{' '}
              <label className={'label--breach inline-block'}>
                {props.limitName === 'RC6' ? '#' : 'JPY'}
              </label>
            </div>
            <ManageContactsButton clientForm={props.clientForm} disconnectedAlert={disconnectAlert} severity={'Notify'} limitName={props.limitName} displayManageContactsOverlay={props.displayManageContactsOverlay} />
          </>
        )}
        {sortedNonDisconnectAlerts.map((value, index) => {
          const severity = index === 0 ? 'Warn' : 'Notify'
          const labelClass = severity === 'Warn' ? 'label--warn' : 'label--notify'
          const badgeClass =
            value.contacts.size > 0 ? 'badge-notify' : 'badge-breach'
          return (
            <React.Fragment key={index}>
              <label className={labelClass}>{severity}</label>
              <div>
                <input
                  type='number'
                  value={value.thresholdInPercent}
                  onChange={(event) => props.alertChangedEvent(value, event.currentTarget.value)}
                  min='0'
                  className='inline-block input no-margin-bottom text-right'
                  required={true}
                /> {' '}
                <label className={labelClass + ' inline-block'}>%</label>
              </div>
              <ManageContactsButton clientForm={props.clientForm} disconnectedAlert={value} severity={severity} limitName={props.limitName} displayManageContactsOverlay={props.displayManageContactsOverlay} />
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}
